// extracted by mini-css-extract-plugin
export default {"headerpa":"Profile_headerpa__MSkni","datos":"Profile_datos__vh9e-","cuadro":"Profile_cuadro__iLGrY","ico":"Profile_ico__64eM8","btonAc":"Profile_btonAc__rRf1Y"};